import urlBuilder from '@sanity/image-url';
import {getImageDimensions} from '@sanity/asset-utils';
import {useSanityClient} from '~/lib/utils';
import type {PortableTextImageBlock} from '~/types/sanityTypes';

export const ImageBlock = ({
  value,
  isInline,
}: {
  value: PortableTextImageBlock;
  isInline?: boolean;
}) => {
  const {width, height} = getImageDimensions(value.image);
  return (
    <div className="pb-10 flex flex-row justify-center">
      <div className="flex flex-col align-middle ">
        <img
          src={urlBuilder(useSanityClient)
            .image(value.image)
            .width(isInline ? 100 : 1200)
            .fit('max')
            .auto('format')
            .url()}
          alt={value.image.altText || ' '}
          loading="lazy"
          style={{
            display: 'block',
            // Avoid jumping around with aspect-ratio CSS property
            aspectRatio: width / height,
          }}
        />
        {value.variant === 'caption' && value.caption !== '' && (
          <div className="text-xs py-2">{value.caption}</div>
        )}
      </div>
    </div>
  );
};
